export default "__VITE_ASSET__6gwHTAgJ__"